import { app } from '../../app';
import { Controller } from './sp-alert.controller';

/**
 * @example
 * <sp-alert options="$ctrl.spAlert"></sp-alert>
 *
 * @example
 * class Controller {
 *   $onInit() {
 *     this.spAlert = new SpAlert('success', 'global.messages.success')
 *   }
 * }
 */
app.component('spAlert', {
    bindings: {options: '<'},
    controller: Controller,
    templateUrl: require('./sp-alert.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-alert/sp-alert.component.js